<template>
    <div>
      <!-- 表格 -->
      <el-table :data="tableData" style="width: 100%" border stripe>
        <!-- 用户名 -->
        <el-table-column prop="username" label="用户名" width="120" />
  
        <!-- 头像 -->
        <el-table-column label="头像" width="100">
          <template #default="{ row }">
            <el-avatar :size="50" :src="row.headPicture" />
          </template>
        </el-table-column>
  
        <!-- 性别 -->
        <el-table-column prop="gender" label="性别" width="80" >
            <template #default = "{ row }">
                <i v-if="row.sex === 1" class="el-icon-male" size="20" color="#409EFF"></i>
                <i v-else-if="row.sex === 2" class="el-icon-female" size="20" color="#F56C6C"></i>
            </template>
        </el-table-column>
  
        <!-- 状态 -->
        <el-table-column label="状态" width="100">
          <template #default="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'">
              {{ row.status === 1 ? '活跃' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
  
        <!-- 最后一次登录时间 -->
        <el-table-column prop="lastLoginTime" label="最后一次登录时间" width="180" />
  
        <!-- 注册时间 -->
        <el-table-column prop="createTime" label="注册时间" width="180" />
  
        <!-- 邮箱 -->
        <el-table-column prop="email" label="邮箱" width="180" />
  
        <!-- 手机号 -->
        <el-table-column prop="phone" label="手机号" width="120" />
  
        <!-- 个人简介 -->
        <el-table-column prop="introduction" label="个人简介" />
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px; text-align: right;"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </template>
  
  <script>
import axios from 'axios';

  export default {
    name:'UserTable',
    data() {
      return {
        //所有用户
        allData:[],
        // 普通用户表格数据
        tableData: [],
        
        // 分页相关数据
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页显示条数
        total:0
      };
    },
 
    mounted(){
        this.queryUser()
    },
    methods: {
      // 当前页码改变
      handlePageChange(page) {
        this.currentPage = page;
        this.queryUser()
      },
      //查询所有用户
      queryUser(){
        const token = sessionStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `${token}`;
        axios.get(`http://www.wjyzlj.cn/pet/user/page?current=${this.currentPage}&pageSize=${this.pageSize}`)
        .then( response => {
            this.allData = response.data.data.records
            //过滤出普通用户
            this.tableData = this.allData.filter(item => item.userType !== 1);
            this.total = response.data.data.total
        })
        .catch( error => {
            console.log(error)
        })
      }
    },
  };
  </script>
  
  <style scoped>
  .el-table {
    margin-top: 20px;
  }
  </style>